export const ALLOW_EDIT_TYPES = Object.freeze({
  ALL: 0,
  ONLY_ADD_MEMBERS: 1,
  NO_EDIT_MEMBERS: 2,
});

export const BUYING_STATUS = Object.freeze({
  ONGOING: 0,
  ENDED: 1,
  FINISHED: 2,
  CANCELED: 3,
  SCHEDULED: 4,
});

export const BUYING_STATUS_TEXT = Object.freeze({
  [BUYING_STATUS.ONGOING]: '開放訂購中',
  [BUYING_STATUS.ENDED]: '已截止訂購',
  [BUYING_STATUS.FINISHED]: '已完成',
  [BUYING_STATUS.CANCELED]: '已取消',
  [BUYING_STATUS.SCHEDULED]: '已公告',
});

export const DEFAULT_PER_PAGE = 25;
export const FIRST_PAGE = 1;

export const FRONT_STAGE_URL = Object.freeze({
  STAGING: 'https://staging.takeorder.tw',
  PRODUCTION: 'https://order.takeorder.tw',
});

export const BACK_STAGE_URL = Object.freeze({
  STAGING: 'https://admin-staging.takeorder.tw',
  PRODUCTION: 'https://admin.takeorder.tw',
});

export const API_RESPONSE_STATUS = Object.freeze({
  NORMAL: 0,
  NOT_AUTH: 401,
});

export const CONSUMPTION_LIMIT = Object.freeze({
  NO_LIMIT: 0,
  AMOUNT: 1,
  ITEMS: 2,
});

export const DRAFT_GET_TYPES = Object.freeze({
  CREATE: 'create',
  EDIT: 'edit',
});

export const NO_DEPARTMENT_ID = 0;

export const NO_DEPARTMENT_NAME = '沒有部門';

export const PER_PAGE_OPTIONS = Object.freeze([
  {
    label: '顯示25筆',
    value: 25,
  },
  {
    label: '顯示50筆',
    value: 50,
  },
  {
    label: '顯示100筆',
    value: 100,
  },
]);

export const SCHEDULE_MAX_COUNT = 100;

export const SCHEDULE_TYPES = Object.freeze({
  DOUBLE_WEEKLY: 'double_weekly',
  MONTHLY: 'monthly',
  PERIOD: 'period',
  WEEKLY: 'weekly',
});

export const KEY_CODES = Object.freeze({
  RIGHT: 39,
  LEFT: 37,
});

export const ORDER_TYPE = Object.freeze({
  DRAFT: 0,
  NORMAL: 1,
  CANCELLED: 2,
  COMPLETED: 3,
});

export const ORDER_STATUS = Object.freeze({
  SCHEDULED: 0,
  ONGOING: 1,
  ENDED: 2,
});

export const ORDER_STATUS_WITH_TYPE_TEXT = Object.freeze({
  ONGOING: 'ongoing',
  SCHEDULED: 'scheduled',
  ENDED: 'ended',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  DRAFT: 'draft',
});

export const ORDER_STATUS_TYPE_MAP = Object.freeze([
  ORDER_STATUS_WITH_TYPE_TEXT.SCHEDULED,
  ORDER_STATUS_WITH_TYPE_TEXT.ONGOING,
  ORDER_STATUS_WITH_TYPE_TEXT.ENDED,
]);

export const ORDER_TYPE_MAP = Object.freeze([
  ORDER_STATUS_WITH_TYPE_TEXT.DRAFT,
  null,
  ORDER_STATUS_WITH_TYPE_TEXT.CANCELLED,
  ORDER_STATUS_WITH_TYPE_TEXT.COMPLETED,
]);

export const ORDER_CARD_TYPE_TEXT_MAP = Object.freeze({
  draft: '草稿',
  scheduled: '已公告',
  ongoing: '開放訂購中',
  ended: '已截止',
  cancelled: '已取消',
  completed: '已完成',
});

export const POSITION = Object.freeze({
  END: 'end',
  START: 'start',
});

export const RECEIVE_TYPE = Object.freeze({
  NONE: 0,
  PARTIAL: 1,
  FULLY: 2,
});

export const RECEIVE_TEXT = Object.freeze({
  [RECEIVE_TYPE.NONE]: '未領取',
  [RECEIVE_TYPE.PARTIAL]: '部分領取',
  [RECEIVE_TYPE.FULLY]: '已領取',
});

export const RECEIVING_STATUS = Object.freeze({
  UNRECEIVED: 0,
  RECEIVED: 1,
  PARTIALLY: 2,
});

export const RECEIVING_STATUS_TEXT = Object.freeze({
  [RECEIVING_STATUS.UNRECEIVED]: '未領取',
  [RECEIVING_STATUS.RECEIVED]: '已領取',
  [RECEIVING_STATUS.PARTIALLY]: '部分領取',
});

export const LAST_WRITE_OFF_STATUS = Object.freeze({
  CANCEL: 0,
  SCAN: 1,
  BACKSTAGE: 2,
});

export const LAST_WRITE_OFF_STATUS_TEXT = Object.freeze({
  [LAST_WRITE_OFF_STATUS.CANCEL]: '取消領取',
  [LAST_WRITE_OFF_STATUS.SCAN]: '掃描核銷',
  [LAST_WRITE_OFF_STATUS.BACKSTAGE]: '後台核銷',
});

export const HISTORY_ORDER_TYPES = Object.freeze([
  ORDER_TYPE.CANCELLED,
  ORDER_TYPE.COMPLETED,
]);

export const HTTP_STATUS = Object.freeze({
  DELETE: 'delete',
  GET: 'get',
  PATCH: 'patch',
  POST: 'post',
  PUT: 'put',
});

export const ORDER_MODES = Object.freeze({
  ORDER: 'order',
  HISTORY: 'history',
});

export const ORDER_STEP_MAPPING = Object.freeze({
  MEMBER_SELECTOR: 'memberSelector',
  ORDER_CONFIG: 'orderConfig',
  ORDER_OVERVIEW: 'orderOverview',
});

export const ORDER_STEP = Object.freeze([
  ORDER_STEP_MAPPING.MEMBER_SELECTOR,
  ORDER_STEP_MAPPING.ORDER_CONFIG,
  ORDER_STEP_MAPPING.ORDER_OVERVIEW,
]);

export const STATISTICS_MODES = Object.freeze({
  DETAILS: 'details',
  LIST: 'list',
});

export const STATISTICS_TYPES = Object.freeze({
  GROUP_BUYING: 'group_buyings',
  MEMBER: 'members',
});

export const STORE_MODES = Object.freeze({
  LIST: 'list',
  CREATE: 'create',
  EDIT: 'edit',
});

export const SNACKBAR_TYPES = Object.freeze({
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
});

export const USER_LEVEL = Object.freeze({
  NORMAL: 0,
  HEAD: 1,
  ADMIN: 2,
  OWNER: 3,
});

export const USER_LEVEL_MAPPING = Object.freeze([
  {
    key: USER_LEVEL.ADMIN,
    name: '管理員',
  },
  {
    key: USER_LEVEL.HEAD,
    name: '團主',
  },
  {
    key: USER_LEVEL.NORMAL,
    name: '一般人員',
  },
  {
    key: USER_LEVEL.OWNER,
    name: '帳號擁有者',
  },
]);

export const MEMBER_MODE = Object.freeze({
  CREATE: 'create',
  BATCH_CREATE: 'batch-create',
  LIST: 'list',
  EDIT: 'edit',
});

export const MEMBER_STATUS = Object.freeze({
  DISABLED: 0,
  ENABLED: 1,
});

export const MEMBER_IMPORTING_STATUS = Object.freeze({
  PENDING: 0,
  PROCESSING: 1,
  COMPLETED: 2,
  FAILED: 3,
});

export const VERIFY_MAIL_TYPES = Object.freeze({
  REGISTER: 'register',
  RESET_PASSWORD: 'resetPassword',
});

export const ON_SITE_ORDER_ITEM_INDEX = -1;

export const PAYMENT_STATUS = Object.freeze({
  UNPAID: 0,
  PARTICALLY: 1,
  PAID: 2,
});

export const PRICE_PER_MEMBER = 30;

export const ENTREE_LIMIT = Object.freeze({
  MINIMUM: 1,
  MAXIMUM: 9999,
});

export const REIMBURSEMENT_SITE_URL = Object.freeze({
  STAGING: 'https://receive-staging.takeorder.tw',
  PRODUCTION: 'https://receive.takeorder.tw',
});

export const LIMIT_TYPE = Object.freeze({
  NO_LIMIT: 0,
  LIMIT_MONEY: 1,
  LIMIT_ITEM: 2,
  LIMIT_ENTREE_COUNT: 3,
});

export const WEEKDAYS = Object.freeze([
  '星期日',
  '星期一',
  '星期二',
  '星期三',
  '星期四',
  '星期五',
  '星期六',
]);

export const TASK_STATUS = Object.freeze({
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
});

export default {
  ALLOW_EDIT_TYPES,
  API_RESPONSE_STATUS,
  DEFAULT_PER_PAGE,
  DRAFT_GET_TYPES,
  ENTREE_LIMIT,
  FIRST_PAGE,
  HISTORY_ORDER_TYPES,
  HTTP_STATUS,
  KEY_CODES,
  LIMIT_TYPE,
  MEMBER_IMPORTING_STATUS,
  MEMBER_MODE,
  MEMBER_STATUS,
  ON_SITE_ORDER_ITEM_INDEX,
  ORDER_CARD_TYPE_TEXT_MAP,
  ORDER_MODES,
  ORDER_STATUS_WITH_TYPE_TEXT,
  ORDER_STATUS,
  ORDER_TYPE,
  PER_PAGE_OPTIONS,
  PRICE_PER_MEMBER,
  REIMBURSEMENT_SITE_URL,
  SCHEDULE_TYPES,
  SNACKBAR_TYPES,
  STATISTICS_MODES,
  STORE_MODES,
  TASK_STATUS,
  USER_LEVEL,
  VERIFY_MAIL_TYPES,
};
